import { render, staticRenderFns } from "./grupos.vue?vue&type=template&id=fae3d1b6&scoped=true&"
import script from "./grupos.vue?vue&type=script&lang=js&"
export * from "./grupos.vue?vue&type=script&lang=js&"
import style0 from "./grupos.vue?vue&type=style&index=0&id=fae3d1b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae3d1b6",
  null
  
)

export default component.exports